import { getDefaultState } from './state';
import { defineStore } from 'pinia';
import bff from '@/shared/api/bff';
import { type IDimeguidanceYouSpouse } from './dimeguidanceStore.model';

export const useDimeguidanceStore = defineStore('dimeguidance', {
  state: getDefaultState,
  // getters,
  // actions,
  // mutations,
  actions: {
    async getData() {
      this.setLoading(true);
      let res;
      try {
        res = await bff.getDimeData();
      } catch (_e) {
        this.setLoading(false);
        return null;
      }
      // TODO add the following
      // this.setDimeData(res.data);
      this.setLoading(false);
      return res.data;
    },

    async calculateYou(dimeData: object) {
      const dimeResults = await bff.dimeCalc(dimeData);
      this.setDimeCalculation({ you: dimeResults });
      return dimeResults;
    },

    async calculateSpouse(dimeData: object) {
      const dimeResults = await bff.dimeCalc(dimeData);
      this.setDimeCalculation({ spouse: dimeResults });
      return dimeResults;
    },

    setIncludeSpouse(includeSpouse: boolean) {
      this.includeSpouse = includeSpouse;
    },

    // setDimeData(data: IDimeguidanceDimeResponse) {
    //   this.dimeData = data;
    //   if (data?.primary?.spouseIncluded === 'Y') {
    //     this.includeSpouse = true;
    //   }
    // },

    setLoading(data: object | boolean) {
      this.dimeLoading = !!data;
    },

    setDimeCalculation(youSpouseObj: IDimeguidanceYouSpouse | null) {
      if (typeof youSpouseObj?.you !== 'undefined') {
        this.dimeCalculation.you = youSpouseObj.you;
      }
      if (typeof youSpouseObj?.spouse !== 'undefined') {
        this.dimeCalculation.spouse = youSpouseObj.spouse;
      }
    },

    resetState() {
      Object.assign(this, getDefaultState());
    },
  },
});
